module.exports = __webpack_public_path__ + "img/list_jd_30.a4909c09.jpg";